import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3.818 6a2.182 2.182 0 1 1 4.364 0 2.182 2.182 0 0 1-4.364 0ZM12 7.09V4.91l-1.576-.297a4.572 4.572 0 0 0-.317-.758l.907-1.326L9.47.986l-1.326.907a4.572 4.572 0 0 0-.758-.317L7.09 0H4.909l-.296 1.576c-.264.083-.517.19-.758.317L2.529.986.986 2.53l.907 1.326a4.572 4.572 0 0 0-.317.758L0 4.91v2.182l1.576.296c.083.264.19.517.317.758L.986 9.471l1.543 1.543 1.326-.907c.241.126.494.234.758.317L4.91 12h2.182l.296-1.576c.264-.083.517-.19.758-.317l1.326.907 1.543-1.543-.907-1.326c.126-.241.234-.494.317-.758L12 7.09Z"
    />
  </svg>
);
export const GearIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
